var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconFingerprint = function SvgIconFingerprint(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.399 8.343a8 8 0 0 1 11.314 0m-3.046 8.324A2.667 2.667 0 0 1 12 14",
    stroke: "#061231",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.23 18a5.271 5.271 0 0 1-1.841-4 2.667 2.667 0 1 1 5.334 0",
    stroke: "#061231",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.797 18a7.952 7.952 0 0 1-1.075-4 5.333 5.333 0 1 1 10.666 0M3 17v2a2 2 0 0 0 2 2h2M21 7V5a2 2 0 0 0-2-2h-2M7 3H5a2 2 0 0 0-2 2v2m14 14h2a2 2 0 0 0 2-2v-2",
    stroke: "#061231",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconFingerprint);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi4zOTkgOC4zNDNhOCA4IDAgMCAxIDExLjMxNCAwbS0zLjA0NiA4LjMyNEEyLjY2NyAyLjY2NyAwIDAgMSAxMiAxNCIgc3Ryb2tlPSIjMDYxMjMxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNMTEuMjMgMThhNS4yNzEgNS4yNzEgMCAwIDEtMS44NDEtNCAyLjY2NyAyLjY2NyAwIDEgMSA1LjMzNCAwIiBzdHJva2U9IiMwNjEyMzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGQ9Ik03Ljc5NyAxOGE3Ljk1MiA3Ljk1MiAwIDAgMS0xLjA3NS00IDUuMzMzIDUuMzMzIDAgMSAxIDEwLjY2NiAwTTMgMTd2MmEyIDIgMCAwIDAgMiAyaDJNMjEgN1Y1YTIgMiAwIDAgMC0yLTJoLTJNNyAzSDVhMiAyIDAgMCAwLTIgMnYybTE0IDE0aDJhMiAyIDAgMCAwIDItMnYtMiIgc3Ryb2tlPSIjMDYxMjMxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";